import React from 'react'
import styles from './ManagerRowSettings.module.scss'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { ReactComponent as Garbage } from 'components/CRM/UI/icons/garbage.svg'

const ManagerRowSettings = ({ manager, disabled, onChange, translate }) => {
  return (
    <div className={styles.managerRow}>
      <div className={styles.nameContainer}>
        <div className={styles.name}>{manager.name}</div>
        <div className={styles.progressBar}>
          <div
            className={styles.progress}
            style={{ backgroundColor: '#F0F3F5' }}
          />
        </div>
      </div>

      <div className={styles.rowInp}>
        <div className={styles.inputSt}>
          <FormInput>
            <input
              type='number'
              placeholder={translate.budget}
              disabled={disabled}
              className={disabled ? styles.disable : styles.disableNan}
              value={manager.budget || ''}
              onChange={(e) => onChange({ budget: e.target.value })}
            />
          </FormInput>
        </div>
        <div className={styles.inputSt}>
          <FormInput disabled={disabled}>
            <input
              type='number'
              placeholder={translate.quantity}
              disabled={disabled}
              className={disabled ? styles.disable : styles.disableNan}
              value={manager.deals || ''}
              onChange={(e) => onChange({ deals: e.target.value })}
            />
          </FormInput>
        </div>
        <button
          className={styles.garbageBtn}
          onClick={() => {
            onChange({ budget: '', deals: '' })
          }}
        >
          <Garbage />
        </button>
      </div>
    </div>
  )
}

export default ManagerRowSettings
